import React, { ReactElement, useEffect, useState } from "react";

import { Context } from "../../../context";
import { TimelineWrapper, TimeDisplay } from "../fieldvision.style";

interface TimelineProps {
  currentTime: number;
  totalTime: number;
  seekToTimelineClick(time: number): void;
  addSubscriberToContextChange: (
    name: string,
    cb: (context: Context) => void
  ) => void;
}

interface TickerProps {
  currentTime: number;
  totalTime: number;
  addSubscriberToContextChange: (
    name: string,
    cb: (context: Context) => void
  ) => void;
}

export function Timeline(props: TimelineProps): ReactElement<TimelineProps> {
  const {
    currentTime,
    totalTime,
    seekToTimelineClick,
    addSubscriberToContextChange,
  } = props;
  const [playCurrentTime, setPlayCurrentTime] = useState(currentTime);
  const [playTotalTime, setPlayTotalTime] = useState(totalTime);

  useEffect(() => {
    addSubscriberToContextChange("timeline", (context: Context) => {
      const playPeriod = context.clock.playPeriod;

      setPlayCurrentTime(context.clock.relativePlay ?? context.clock.relative);
      setPlayTotalTime(playPeriod ?? context.clock.timelinePeriod);
    });
  }, []);

  const style = {
    backgroundSize: `${
      playTotalTime ? (playCurrentTime / playTotalTime) * 100 : 0
    }% 100%`,
  };

  return (
    <TimelineWrapper title="timeline">
      <input
        type="range"
        max={playTotalTime}
        min="0"
        value={playCurrentTime}
        style={style}
        step="0.01"
        onChange={(e) => {
          seekToTimelineClick(parseFloat(e.target.value));
        }}
      />
    </TimelineWrapper>
  );
}

export function TickerElapsed(props: TickerProps): ReactElement<TickerProps> {
  const { currentTime, addSubscriberToContextChange } = props;
  const [playCurrentTime, setPlayCurrentTime] = useState(currentTime);

  useEffect(() => {
    addSubscriberToContextChange("tickerElapsed", (context: Context) => {
      setPlayCurrentTime(context.clock.relativePlay ?? context.clock.relative);
    });
  }, []);

  return (
    <TimeDisplay>
      <div>{formatTime(playCurrentTime)}</div>
    </TimeDisplay>
  );
}

export function TickerTotal(props: TickerProps): ReactElement<TickerProps> {
  const { totalTime, addSubscriberToContextChange } = props;
  const [playTotalTime, setPlayTotalTime] = useState(totalTime);

  useEffect(() => {
    addSubscriberToContextChange("tickerTotal", (context: Context) => {
      const playPeriod = context.clock.playPeriod;
      setPlayTotalTime(playPeriod ?? context.clock.timelinePeriod);
    });
  }, []);

  return (
    <TimeDisplay>
      <div>{formatTime(playTotalTime)}</div>
    </TimeDisplay>
  );
}

function formatTime(seconds: number) {
  let minutes = Math.floor(seconds / 60);

  seconds = Math.floor(seconds % 60);
  let secondsDisplay = seconds >= 10 ? seconds : "0" + seconds;

  return seconds > 0 ? minutes + ":" + secondsDisplay : "0:00";
}
